<div class="content">
  <div class="date-card">
    <div class="title">
      <span class="day">Day</span>
      <span class="vis">Visitors</span>
    </div>

    <div *ngIf="!days" style="width: 290px; height: 220px"></div>
    <div *ngIf="days">
      <div class="dates" *ngFor="let item of days | keyvalue">
        <span class="date">{{ getDay(item.key) }}<br />{{ getMonth(item.key) }}</span>
        <span class="numbers">{{ item.value }}</span>
      </div>
    </div>
  </div>
</div>
